// src/pages/ClinicalDataCollector/components/output/CVRiskScore10Y.jsx

// src/pages/ClinicalDataCollector/components/output/CVRiskScore10Y.jsx

import React, { useMemo } from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Divider
} from '@mui/material';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import { PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';
import { useSelector } from 'react-redux';

// 👇 nuevo: importamos la data simulada
import cvRiskData from '../data/cvRiskScore10YData.json';

const COLORS = ['#ff7f50', '#d3d3d3'];

const CVRiskScore10Y = () => {
  const { PatientSelect } = useSelector((state) => state.patientMapSelect || {});
  const patients = cvRiskData?.patients || [];

  const selectedPatient = useMemo(() => {
    if (!patients.length) return null;

    if (PatientSelect?.memberId) {
      const base =
        (PatientSelect.memberId.length || 1) +
        (PatientSelect.age || 0) * 17;
      const idx = Math.abs(base) % patients.length;
      return patients[idx];
    }

    const randomIdx = Math.floor(Math.random() * patients.length);
    return patients[randomIdx];
  }, [PatientSelect, patients]);

  if (!selectedPatient) return null;

  const { name, profile, riskPercent, statinPlan, additionalTherapies } =
    selectedPatient;

  const chartData = [
    { name: 'Risk', value: riskPercent },
    { name: 'No Risk', value: 100 - riskPercent }
  ];

  return (
    <Card elevation={3} sx={{ borderRadius: 2, mb: 4 }}>
      <CardHeader
        title="10-Year Cardiovascular Risk"
        // subheader={`Simulated profile: ${name} — ${profile}`}
        titleTypographyProps={{ variant: 'h5', align: 'center' }}
        action={<ShowChartIcon fontSize="large" color="primary" />}
      />
      <Divider />
      <CardContent>
        <Typography
          variant="h4"
          align="center"
          sx={{ my: 2, fontWeight: 'bold' }}
        >
          {riskPercent}%
        </Typography>
        <PieChart width={300} height={200}>
          <Pie
            data={chartData}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            innerRadius={60}
            outerRadius={80}
            label={(entry) => `${entry.name}: ${entry.value.toFixed(1)}%`}
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip formatter={(value) => `${value.toFixed(1)}%`} />
          <Legend verticalAlign="bottom" height={36} />
        </PieChart>
        <Typography variant="subtitle1" sx={{ mt: 3, fontWeight: 'medium' }}>
          Statin Plan:
        </Typography>
        <Typography variant="body2" paragraph>
          {statinPlan}
        </Typography>
        <Typography variant="subtitle1" sx={{ fontWeight: 'medium' }}>
          Additional Therapies:
        </Typography>
        <ul>
          {additionalTherapies.map((therapy, idx) => (
            <li key={idx}>
              <Typography variant="body2">{therapy}</Typography>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
};

export default CVRiskScore10Y;

